import { render } from "./ColumnTab.vue?vue&type=template&id=19179c88&scoped=true&ts=true"
import script from "./ColumnTab.vue?vue&type=script&lang=ts"
export * from "./ColumnTab.vue?vue&type=script&lang=ts"

import "./ColumnTab.vue?vue&type=style&index=0&id=19179c88&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19179c88"]])

export default __exports__